import en_US from './en_US.json';
// import other language files here

export default { en_US };
